/* eslint-disable react-hooks/exhaustive-deps */
"use client"

import { Box, Grid, makeStyles } from "@material-ui/core"
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend } from "chart.js"
import InputsGroup from "./InputsGroup"
import { useEffect, useState } from "react"
import { getAccumulatedByPurchasesBySupplierRequest, getAccumulatedBySupplierPurchasesRequest, getBillsByBuyerRequest, getBillsByFamilyElementsRequest, getBillsByFamilyRequest, getBillsDetailsElementsTwoRequest, getBOrdersServeRequest, getBuyOrderChangeRequest, getBuyOrderDataRequest, getBuyOrderDetailsOrderRequest, getBuyOrderDetailsRequest, getCicleByPaymentTypeElementsRequest, getCycleByPaymentTypeRequest, getPaymentTypesList, getPercentageAttendedOrdersRequest, getPercentageByOrderElementsRequest, getPercentageByOrderRequest, getPercentageProductionByBuyerRequest, getPercentageRequirementsNumberRequest, getProjetsByCompanyRequest, getPurchaseOrderListRequest, resetBillsByFamily, resetElements, resetProjetsByCompanyRequest } from "../../actions/logistic-indicators.action"
import { useDispatch, useSelector } from "react-redux"
import BudgetChart from "./BudgetChart"
import FilterableDataGridModal from "../../components/FilterableDataGridModal"
import DoughnutChart from "./DoughnutChart"
import VerticalBarChart from "./VerticalBarChart"
import BuyOrderModal from "./BuyOderModal"
import { useGeneralFilters } from "../../hooks/useLocalStorageFilters"

ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend)

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing(3),
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
    },
    paper: {
        padding: theme.spacing(2),
        height: 300,
    },
    title: {
        fontSize: "0.9rem",
        color: "#1976d2",
        marginBottom: theme.spacing(1),
    },
    chartContainer: {
        height: "calc(100% - 40px)",
    },
}))


const generateDistinctColors = (count) => {
  const colors = [];
  
  for (let i = 0; i < count; i++) {
    const hue = (i * 137.5) % 360;
    const saturation = 70 + Math.random() * 25;
    const lightness = 50 + Math.random() * 20; 
    
    colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
  }
  
  return colors;
};

let elementsRequest = () => {};
let elementsDoubleClick = () => {};
let secondsElementsDoubleClickAction = (data) => {console.log(data)};

export default function DashboardPage() {
  const classes = useStyles()
  const dispatch = useDispatch();
  const logisticIndicators = useSelector((state) => state.logisticIndicators);
  const { filters, updateFilter } = useGeneralFilters({
    selectedCoin: "PEN",
    selectedCompany: "",
    mode: "-1",
    startDate: `01/05/2020`,
    endDate: `31/12/${new Date().getFullYear()}`,
    period: "0",
    selectedProject: '',
    billsByFamilyLevel: "1",
  });
  
  const {
    selectedCoin,
    selectedCompany,
    mode,
    startDate,
    endDate,
    period,
    selectedProject,
    billsByFamilyLevel,
  } = filters;
  
  const setSelectedCoin = (value) => updateFilter('selectedCoin', value);
  const setSelectedCompany = (value) => updateFilter('selectedCompany', value);
  const setMode = (value) => updateFilter('mode', value);
  const setStartDate = (value) => updateFilter('startDate', value);
  // const setEndDate = (value) => updateFilter('endDate', value);
  const setPeriod = (value) => updateFilter('period', value);
  const setSelectedProject = (value) => updateFilter('selectedProject', value);
  const setBillsByFamilyLevel = (value) => updateFilter('billsByFamilyLevel', value);

  const [selectedIndicatorTitle, setSelectedIndicatorTitle] = useState()
  const [selectedItem, setSelectedItem] = useState()
  const [selectedItemColumns, setSelectedItemColumns] = useState([])
  const [selectedItemColumnsTwo, setSelectedItemColumnsTwo] = useState([])
  const [secondsElementsData, setSecondsElementsData] = useState()
  const [buyOrderData, setBuyOrderData] = useState()
  const [searchText, setSearchText] = useState('');
  const [searchTextTwo, setSearchTextTwo] = useState('');
  
  useEffect(() => {
    // updateFilter('selectedProject', '');
    dispatch(resetProjetsByCompanyRequest());
    getProjetsByCompanyRequest(selectedCompany, startDate, endDate);
  }, [selectedCompany, startDate, endDate])

  useEffect(() => {
    dispatch(resetBillsByFamily());
    getBillsByFamilyRequest(selectedProject, selectedCompany, billsByFamilyLevel, startDate, endDate);
  }, [selectedProject, selectedCompany, startDate, endDate, billsByFamilyLevel])

  useEffect(() => {
    getPaymentTypesList(startDate, endDate);
    getPurchaseOrderListRequest(selectedProject, selectedCompany, startDate, endDate);
    getBillsByBuyerRequest(selectedProject, selectedCompany, startDate, endDate);
    getBOrdersServeRequest(selectedProject, selectedCompany, startDate, endDate);
    getAccumulatedBySupplierPurchasesRequest(selectedProject, selectedCompany, startDate, endDate);
    getPercentageByOrderRequest(selectedProject, selectedCompany, startDate, endDate);
    getCycleByPaymentTypeRequest(selectedProject, selectedCompany, startDate, endDate);
  }, [selectedProject, selectedCompany, startDate, endDate])

  useEffect(() => {
    if (!logisticIndicators.elementsTotalItems || logisticIndicators.elementsTotalItems <= 100) {
      return;
    }
    const pages = Math.ceil(logisticIndicators.elementsTotalItems / 100)
    for (let i = 1; i < pages; i++) {
      elementsRequest(i + 1)
    }
  }, [logisticIndicators.elementsTotalItems])

  const processCicleByPaymentTypeSimple = (data, selectedCoin) => {
    const uniquePayments = [...new Set(data.map(item => item.CodFormaDePago))];
    
    const labels = [];
    const servicioData = [];
    const compraData = [];
    const completeData = [];
  
    uniquePayments.forEach(codigo => {
      const items = data.filter(item => item.CodFormaDePago === codigo);
      const firstItem = items[0];
      
      const servicioItem = items.find(item => item.Tipo === "Orden de Servicio");
      const compraItem = items.find(item => item.Tipo === "Orden de Compra");
      
      const servicioValue = servicioItem ? 
        (selectedCoin === 'PEN' ? servicioItem.CostoPEN : servicioItem.CostoUSD) : 0;
      
      const compraValue = compraItem ? 
        (selectedCoin === 'PEN' ? compraItem.CostoPEN : compraItem.CostoUSD) : 0;
  
      if (servicioValue > 0 || compraValue > 0) {
        labels.push(firstItem.Descripcion);
        servicioData.push(servicioValue);
        compraData.push(compraValue);
        
        completeData.push({
          id: codigo,
          descripcion: firstItem.Descripcion,
          ordenServicio: servicioValue,
          ordenCompra: compraValue,
          total: servicioValue + compraValue
        });
      }
    });
  
    const sortedIndices = completeData
      .map((item, index) => ({ index, total: item.total }))
      .sort((a, b) => b.total - a.total)
      .map(item => item.index);
  
    return {
      labels: sortedIndices.map(i => labels[i]),
      datasets: [
        {
          label: "Orden de Servicio",
          data: sortedIndices.map(i => servicioData[i]),
          backgroundColor: "#fc3d73",
        },
        {
          label: "Orden de Compra", 
          data: sortedIndices.map(i => compraData[i]),
          backgroundColor: "#52baa7",
        }
      ],
      completeData: sortedIndices.map(i => completeData[i])
    };
  };

  const handleBuyOrderData = (data) => {
    setBuyOrderData(data)
    getBuyOrderDataRequest(data.id);
    getBuyOrderChangeRequest(startDate, selectedCoin);
    getBuyOrderDetailsRequest(data.id)
    getBuyOrderDetailsOrderRequest(data.id)
  }

  const percentageByOrder = {
    labels: logisticIndicators.percentageByOrder.map(p => p.TipoOrden),
    datasets: [
      {
        data: logisticIndicators.percentageByOrder.map(p => selectedCoin === 'PEN' ? p.PorcentajePEN : p.PorcentajeUSD),
        backgroundColor: ["#3498db", "#e74c3c"],
        borderWidth: 0,
      },
    ],
  }

  const pedidosAtendidosData = {
    labels: logisticIndicators.ordersServe.map(p => p.EstadoPedidoCompra),
    datasets: [
      {
        label: "Pedidos",
        data: logisticIndicators.ordersServe.map(p => p.Porcentaje),
        backgroundColor: ["#9b59b6", "#9b59b6", "#9b59b6"],
        borderRadius: 4,
      },
    ],
  }

  const buyerProductionData = {
    labels: logisticIndicators.billsByBuyer.map(p => p.Descripcion),
    datasets: [
      {
        data: logisticIndicators.billsByBuyer.map(p => selectedCoin === 'PEN' ? p.PorcentajePEN : p.PorcentajeUSD),
        backgroundColor: generateDistinctColors(logisticIndicators.billsByBuyer.length),
        borderWidth: 0,
      },
    ],
  }

  const requirementsQuantity = {
    labels: logisticIndicators.purchaseOrderList.map(p => p.TipoCompra) || [],
    datasets: [
      {
        data: logisticIndicators.purchaseOrderList.map(p => p.Porcentaje) || [],
        backgroundColor: ["#52b788", "#a7c957"],
        borderWidth: 0,
      },
    ],
  }

  const verticalBarOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 70,
      },
    },
  }

  const doughnutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "bottom",
      },
    },
    cutout: "70%",
  }


  const billsByFamilyDoubleClick = (item) => {
    setSelectedIndicatorTitle('Total Gasto por familia');
    setSelectedItem(item);
    dispatch(resetElements());
    elementsRequest = (page) => {
      getBillsByFamilyElementsRequest(selectedProject, selectedCompany, item.id, startDate, page)
    }

    elementsDoubleClick = (data, page= 1) => {
      setSecondsElementsData({
        ...data,
        title: data.Descripcion
      });
      
      setSelectedItemColumnsTwo([
        {
          filterType: 'text',
          headerName: 'Código',
          field: 'CodOrden',
        },
        {
          filterType: 'text',
          headerName: 'Empresa',
          field: 'Empresa',
        },
        {
          filterType: 'text',
          headerName: 'Centro Compra',
          field: 'CentroCompra',
        },
        {
          filterType: 'text',
          headerName: 'Proyecto',
          field: 'Proyecto',
        },
        {
          filterType: 'text',
          headerName: 'Proveedor',
          field: 'Proveedor',
        },
        {
          filterType: 'text',
          headerName: 'Moneda',
          field: 'Moneda',
        },
        {
          filterType: 'text',
          headerName: 'Estado',
          field: 'Estado',
        },
        {
          filterType: 'text',
          headerName: 'Fecha',
          field: 'Fecha',
        },
        {
          filterType: 'text',
          headerName: 'Insumo',
          field: 'Insumo',
        },
        {
          filterType: 'number',
          headerName: 'Costo',
          field: selectedCoin === 'PEN' ? 'CostoPEN' : 'CostoUSD',
        },
      ])
      getBillsDetailsElementsTwoRequest(selectedProject, selectedCompany, 'null', data.id, startDate, page)
    };

    secondsElementsDoubleClickAction = handleBuyOrderData

    elementsRequest(1)
    setSelectedItemColumns([
      {
        filterType: 'text',
        headerName: 'Código',
        field: 'CodInsumo',
      },
      {
        filterType: 'text',
        headerName: 'Descripción',
        field: 'Descripcion',
      },
      {
        filterType: 'text',
        headerName: 'Unidad',
        field: 'Unidad',
      },
      {
        filterType: 'number',
        headerName: 'Cantidad',
        field: 'Cantidad',
      },
      {
        filterType: 'number',
        headerName: 'Costo',
        field: selectedCoin === 'PEN' ? 'CostoPEN' : 'CostoUSD',
      },
    ])
  }

  const cicleByPaymentTypeDoubleClick = (item, datasetIndex) => {
    setSelectedIndicatorTitle('Ciclo por Forma de Pago');
    const type = datasetIndex === 0 ? "Orden de Servicio" : "Orden de Compra";
    const itemData = logisticIndicators.cicleByPaymentType
      .find(p => p.Tipo === type && p.Descripcion === item.label)
    setSelectedItem({
      itemData,
      label: itemData.Descripcion
    });
    dispatch(resetElements());
    elementsRequest = (page) => getCicleByPaymentTypeElementsRequest(
      selectedProject, 
      selectedCompany, 
      datasetIndex === 0 ? 1 : 0,
      itemData.CodFormaDePago, 
      startDate,
      page
    )
    elementsDoubleClick = handleBuyOrderData
    elementsRequest(1)
    setSelectedItemColumns([
      {
        filterType: 'text',
        headerName: 'Código',
        field: 'CodOrden',
      },
      {
        filterType: 'text',
        headerName: 'Empresa',
        field: 'Empresa',
      },
      {
        filterType: 'text',
        headerName: 'Centro Compra',
        field: 'CentroCompra',
      },
      {
        filterType: 'text',
        headerName: 'Proyecto',
        field: 'Proyecto',
      },
      {
        filterType: 'text',
        headerName: 'Proveedor',
        field: 'Proveedor',
      },
    ])
  }

  const PercentageByOrderDoubleClick = (event) => {
    setSelectedIndicatorTitle('Porcentaje por Orden OC/OS');
    const itemData = logisticIndicators.percentageByOrder[event.index]
    const id = itemData.TipoOrden === 'Orden de Servicio' ? 1 : 0;
    setSelectedItem({
      itemData,
      id,
      label: itemData.TipoOrden,
    });
    dispatch(resetElements());
    elementsRequest = (page) => getPercentageByOrderElementsRequest(
      selectedProject, 
      selectedCompany, 
      id,
      startDate,
      page
    )
    elementsDoubleClick = handleBuyOrderData
    elementsRequest(1)
    setSelectedItemColumns([
      {
        filterType: 'text',
        headerName: 'Código',
        field: 'CodOrden',
      },
      {
        filterType: 'text',
        headerName: 'Empresa',
        field: 'Empresa',
      },
      {
        filterType: 'text',
        headerName: 'Centro Compra',
        field: 'CentroCompra',
      },
      {
        filterType: 'text',
        headerName: 'Proyecto',
        field: 'Proyecto',
      },
      {
        filterType: 'text',
        headerName: 'Proveedor',
        field: 'Proveedor',
      },
    ])
  }

  const accumulatedByPurchasesBySupplierDoubleClick = (item) => {
    setSelectedIndicatorTitle('Acumulado por compras del proveedor');
    setSelectedItem(item);
    dispatch(resetElements());
    elementsRequest = (page) => {
      getAccumulatedByPurchasesBySupplierRequest(selectedProject, selectedCompany, item.id, startDate, page)
    }

    elementsDoubleClick = (data, page= 1) => {
      setSecondsElementsData({
        ...data,
        title: data.Descripcion
      });
      
      setSelectedItemColumnsTwo([
        {
          filterType: 'text',
          headerName: 'Código',
          field: 'CodOrden',
        },
        {
          filterType: 'text',
          headerName: 'Empresa',
          field: 'Empresa',
        },
        {
          filterType: 'text',
          headerName: 'Centro Compra',
          field: 'CentroCompra',
        },
        {
          filterType: 'text',
          headerName: 'Proyecto',
          field: 'Proyecto',
        },
        {
          filterType: 'text',
          headerName: 'Proveedor',
          field: 'Proveedor',
        },
        {
          filterType: 'text',
          headerName: 'Moneda',
          field: 'Moneda',
        },
        {
          filterType: 'text',
          headerName: 'Estado',
          field: 'Estado',
        },
        {
          filterType: 'text',
          headerName: 'Fecha',
          field: 'Fecha',
        },
        {
          filterType: 'text',
          headerName: 'Insumo',
          field: 'Insumo',
        },
        {
          filterType: 'number',
          headerName: 'Costo',
          field: selectedCoin === 'PEN' ? 'CostoPEN' : 'CostoUSD',
        },
      ])
      getBillsDetailsElementsTwoRequest(selectedProject, selectedCompany, 'null', data.id, startDate, page)
    };
    secondsElementsDoubleClickAction = handleBuyOrderData
    elementsRequest(1)
    console.log('item', item)
    setSelectedItemColumns([
      {
        filterType: 'text',
        headerName: 'Código',
        field: 'CodInsumo',
      },
      {
        filterType: 'text',
        headerName: 'Descripción',
        field: 'Descripcion',
      },
      {
        filterType: 'text',
        headerName: 'Unidad',
        field: 'Unidad',
      },
      {
        filterType: 'number',
        headerName: 'Cantidad',
        field: 'Cantidad',
      },
      {
        filterType: 'number',
        headerName: 'Costo',
        field: selectedCoin === 'PEN' ? 'CostoPEN' : 'CostoUSD',
      },
    ])
  }

  const percentageAttendedOrdersDoubleClick = (item) => {
    setSelectedIndicatorTitle('% de Pedidos Atendidos');
    const itemData = logisticIndicators.ordersServe[item.index];
    itemData.id = itemData.CodEstadoPedidoCompra;
    itemData.label = itemData.EstadoPedidoCompra;
    setSelectedItem(itemData);
    dispatch(resetElements());
    elementsRequest = (page) => {
      getPercentageAttendedOrdersRequest(selectedProject, selectedCompany, itemData.id, startDate, page)
    }
    elementsDoubleClick = handleBuyOrderData
    elementsRequest(1)
    console.log('itemData', itemData)
    setSelectedItemColumns([
      {
        filterType: 'text',
        headerName: 'Código',
        field: 'CodPedido',
      },
      {
        filterType: 'text',
        headerName: 'Empresa',
        field: 'Empresa',
      },
      {
        filterType: 'text',
        headerName: 'Centro Compra',
        field: 'CentroCompra',
      },
      {
        filterType: 'text',
        headerName: 'Proyecto',
        field: 'Proyecto',
      },
      {
        filterType: 'text',
        headerName: 'Estado Compra',
        field: 'EstadoCompra',
      },
    ])
  }

  const percentageProductionByBuyerDoubleClick = (event) => {
    setSelectedIndicatorTitle('% Produccion por Comprador');
    const itemData = logisticIndicators.billsByBuyer[event.index]
    console.log('itemData', itemData)
    setSelectedItem({
      itemData,
      id: itemData.CodComprador,
      label: itemData.Descripcion,
    });
    dispatch(resetElements());
    elementsRequest = (page) => getPercentageProductionByBuyerRequest(
      selectedProject, 
      selectedCompany, 
      itemData.CodComprador,
      startDate,
      page
    )
    elementsDoubleClick = handleBuyOrderData
    elementsRequest(1)
    setSelectedItemColumns([
      {
        filterType: 'text',
        headerName: 'Código',
        field: 'CodOrden',
      },
      {
        filterType: 'text',
        headerName: 'Empresa',
        field: 'Empresa',
      },
      {
        filterType: 'text',
        headerName: 'Centro Compra',
        field: 'CentroCompra',
      },
      {
        filterType: 'text',
        headerName: 'Proyecto',
        field: 'Proyecto',
      },
      {
        filterType: 'text',
        headerName: 'Proveedor',
        field: 'Proveedor',
      },
    ])
  }

  const percentageRequirementsNumberDoubleClick = (event) => {
    setSelectedIndicatorTitle('% Numero de Requerimientos');
    const itemData = logisticIndicators.purchaseOrderList[event.index]
    console.log('itemData', itemData)
    const id = itemData.TipoCompra === "Compra" ? 0 : 1;
    setSelectedItem({
      itemData,
      id,
      label: itemData.TipoCompra,
    });

    dispatch(resetElements());
    elementsRequest = (page) => getPercentageRequirementsNumberRequest(
      selectedProject, 
      selectedCompany, 
      id,
      startDate,
      page
    )
    elementsDoubleClick = handleBuyOrderData
    elementsRequest(1)
    setSelectedItemColumns([
      {
        filterType: 'text',
        headerName: 'Código',
        field: 'CodPedido',
      },
      {
        filterType: 'text',
        headerName: 'Empresa',
        field: 'Empresa',
      },
      {
        filterType: 'text',
        headerName: 'Centro Compra',
        field: 'CentroCompra',
      },
      {
        filterType: 'text',
        headerName: 'Proyecto',
        field: 'Proyecto',
      },
      {
        filterType: 'text',
        headerName: 'Estado Compra',
        field: 'EstadoCompra',
      },
      {
        filterType: 'text',
        headerName: 'Almacén',
        field: 'Almacen',
      },
      {
        filterType: 'text',
        headerName: 'Tipo',
        field: 'Tipo',
      },
    ])
  }

  const transformDataTo100Percent = (data) => {
    if (!data || !data.labels || !data.datasets) return data;
    
    const { labels, datasets } = data;
    
    const totals = labels.map((_, index) => {
      return datasets.reduce((sum, dataset) => sum + (dataset.data[index] || 0), 0);
    });
    
    const transformedDatasets = datasets.map(dataset => {
      const originalData = [...dataset.data];
      const percentageData = dataset.data.map((value, index) => {
        if (totals[index] === 0) return 0;
        return (value / totals[index]) * 100;
      });
      
      return {
        ...dataset,
        data: percentageData,
        _originalData: originalData,
        _label: dataset.label
      };
    });
    
    return {
      labels,
      datasets: transformedDatasets,
      _totals: totals
    };
  };

  const create100PercentTooltipOptions = (transformedData) => {
    return {
      callbacks: {
        label: function(context) {
          // console.log('contex', context)
          const chart = context.chart;
          const data = chart.data;
          const datasetIndex = context.datasetIndex;
          const dataIndex = context.dataIndex;
          const dataset = data.datasets[datasetIndex];
          const originalValue = dataset._originalData ? dataset._originalData[dataIndex] : dataset.data[dataIndex];
          const percentageValue = dataset.data[dataIndex];
          
          return ` ${originalValue.toFixed(2)} (${percentageValue.toFixed(1)}%)`;
        },
        afterLabel: function(context) {
          console.log(context)
          return '';
        },
      }
    };
  };


  const result = processCicleByPaymentTypeSimple(logisticIndicators.cicleByPaymentType, selectedCoin);

  const cicleByPaymentType = {
    labels: result.labels,
    datasets: result.datasets
  };

  const cicleByPaymentType100Percent = transformDataTo100Percent(cicleByPaymentType);

  const tooltipOptions = create100PercentTooltipOptions(cicleByPaymentType100Percent);
  const stacked100PercentOptions = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "bottom",
      },
      title: {
        display: true,
        text: 'Ciclo por Forma de Pago',
        font: {
          size: 12,
          weight: 'bold'
        },
        color: '#1976d2',
        padding: {
          top: 20,
          bottom: 10
        }
      },
      tooltip: {
        ...tooltipOptions,
        displayColors: true,
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        titleColor: '#333',
        bodyColor: '#666',
        borderColor: '#ddd',
        borderWidth: 1,
        mode: 'index',
        intersect: false,
        position: 'nearest',
        axis: 'y',
        callbacks: {
          ...tooltipOptions.callbacks,
          beforeBody: function(tooltipItems) {
            return '';
          }
        }
      }
    },
    scales: {
      x: {
        min: 0,
        max: 100,
        stacked: true,
        grid: {
          display: true,
        },
        ticks: {
          callback: function(value) {
            return value + '%';
          }
        }
      },
      y: {
        stacked: true,
        grid: {
          display: false,
        },
      },
    },
    
    interaction: {
      mode: 'index',
      axis: 'y',
      intersect: false
    },
    elements: {
      bar: {
        hoverBackgroundColor: undefined,
        hoverBorderColor: undefined,
        hoverBorderWidth: 2
      }
    }
  };

  return (
    <Box className={classes.root}>
    <InputsGroup
      selectedCoin={selectedCoin}
      setSelectedCoin={setSelectedCoin}
      selectedCompany={selectedCompany}
      setSelectedCompany={(value) => {
        setSelectedProject(null);
        setSelectedCompany(value);
      }}
      mode={mode}
      setMode={setMode}
      startDate={startDate}
      setStartDate={setStartDate}
      // endDate={endDate}
      // setEndDate={setEndDate}
      period={period}
      setPeriod={setPeriod}
      selectedProject={selectedProject}
      setSelectedProject={setSelectedProject}
    />
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <BudgetChart 
            title='Total Gasto por familia'
            selectedCoin={selectedCoin}
            selectedStructure={billsByFamilyLevel}
            setSelectedStructure={setBillsByFamilyLevel}
            requiresStructure={false}
            itemsData={logisticIndicators.billByGroup}
            customStructure={[
              {Nivel: '1', Descripcion: 'Nivel 1'},
              {Nivel: '2', Descripcion: 'Nivel 2'},
              {Nivel: '3', Descripcion: 'Nivel 3'},
            ]}
            itemsPerPage={3}
            handleRowDoubleClick={billsByFamilyDoubleClick}
            mainColor='#8A2BE2'
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <BudgetChart 
            title='Ciclo por Forma de Pago'
            selectedCoin={selectedCoin}
            requiresStructure={false}
            data={cicleByPaymentType100Percent}
            options={stacked100PercentOptions}
            itemsPerPage={4}
            handleRowDoubleClick={cicleByPaymentTypeDoubleClick}
            stackTo100Percent={true}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <DoughnutChart 
            title={'Porcentaje por Orden OC/OS'}
            data={percentageByOrder} 
            options={doughnutOptions}
            handleRowDoubleClick={PercentageByOrderDoubleClick}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <BudgetChart 
            title='Acumulado por compras del proveedor'
            selectedCoin={selectedCoin}
            requiresStructure={false}
            itemsData={logisticIndicators.accumulatedBySupplierPurchases.map(i => ({
              id: i.CodIdentificador,
              description: i.Descripcion,
              SaldoPEN: i.CostoPEN,
              SaldoUSD: i.CostoUSD,
            }))}
            itemsPerPage={4}
            handleRowDoubleClick={accumulatedByPurchasesBySupplierDoubleClick}
            mainColor='#007bff'
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <VerticalBarChart 
            title='% de Pedidos Atendidos'
            selectedCoin={selectedCoin}
            data={pedidosAtendidosData}
            handleRowDoubleClick={percentageAttendedOrdersDoubleClick}
            options={verticalBarOptions}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <DoughnutChart 
            title={'% Produccion por Comprador'}
            data={buyerProductionData} 
            options={doughnutOptions}
            handleRowDoubleClick={percentageProductionByBuyerDoubleClick}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <DoughnutChart 
            title={'% Numero de Requerimientos'}
            data={requirementsQuantity} 
            options={doughnutOptions}
            handleRowDoubleClick={percentageRequirementsNumberDoubleClick}
          />
        </Grid>
      </Grid>
      {selectedItem &&
        <FilterableDataGridModal
          onClose={() => {
            setSelectedItem(null);
            setSelectedIndicatorTitle(null)
          }}
          onRowDoubleClick={elementsDoubleClick}
          open={true}
          title={`${selectedIndicatorTitle}: ${selectedItem?.label}`}
          columns={selectedItemColumns}
          rows={logisticIndicators.elements}
          searchText={searchText}
          setSearchText={setSearchText}
        />
      }
      {secondsElementsData &&
        <FilterableDataGridModal
          onClose={() => {
            setSecondsElementsData(null)
            elementsDoubleClick = () => {};
          }}
          onRowDoubleClick={secondsElementsDoubleClickAction}
          open={true}
          title={`${secondsElementsData?.Descripcion || secondsElementsData?.label}`}
          columns={selectedItemColumnsTwo}
          rows={logisticIndicators.elementsTwo}
          searchText={searchTextTwo}
          setSearchText={setSearchTextTwo}
        />
      }
      {buyOrderData && <BuyOrderModal
        open={true}
        title='Detalle'
        paramBuyOrderData={buyOrderData}
        onClose={() => {
          secondsElementsDoubleClickAction = (data) => {console.log(data)};
          setBuyOrderData(undefined);
        }}
      />}
    </Box>
  )
}
